import React, { useState } from 'react';
import {
  Modal,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Clipboard, // Usando o nativo para cumprir a regra de 0 libs externas
  Platform
} from 'react-native';

export default function CopyDialog({ textToCopy, isOpen, onClose, customer }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    // Copia o texto para a área de transferência do celular (iOS e Android)
    Clipboard.setString(textToCopy);
    
    // Dispara o estado de sucesso (botão verde)
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2200);
  };

  return (
    <Modal
      visible={isOpen}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose} // Requisito do Android para o botão voltar nativo
    >
      {/* Overlay escuro. O TouchableWithoutFeedback fecha o modal ao clicar fora */}
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={styles.overlay}>
          
          {/* O TouchableWithoutFeedback interno evita que clicar no card feche o modal */}
          <TouchableWithoutFeedback>
            <View style={styles.card}>
              
              {/* Cabeçalho */}
              <View style={styles.header}>
                <View style={styles.headerTextContainer}>
                  <Text style={styles.title}>Use esse cádigo para pagamento via PIX</Text>
                  <Text style={styles.subtitle}>{customer}</Text>
                </View>
                
                {/* Botão Fechar (Usando caractere unicode já que não podemos usar SVG) */}
                <TouchableOpacity 
                  onPress={onClose} 
                  style={styles.closeButton}
                  activeOpacity={0.6}
                >
                  <Text style={styles.closeIcon}>✕</Text>
                </TouchableOpacity>
              </View>

              {/* Input + Botão */}
              <View style={styles.inputContainer}>
                <TextInput
                  value={textToCopy}
                  editable={false} // Mantém como readonly
                  style={styles.input}
                  numberOfLines={1}
                />
                
                <TouchableOpacity
                  onPress={handleCopy}
                  activeOpacity={0.8}
                  style={[
                    styles.copyButton,
                    copied ? styles.buttonSuccess : styles.buttonDefault
                  ]}
                >
                  <Text style={styles.buttonText}>
                    {copied ? '✓ Copiado' : '📋 Copiar'}
                  </Text>
                </TouchableOpacity>
              </View>

            </View>
          </TouchableWithoutFeedback>
          
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
}

// ==========================================
// CSS TRADUZIDO PARA O STYLESHEET NATIVO
// ==========================================
const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(2, 6, 23, 0.75)', // Fundo slate-950 com opacidade
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 24,
    width: '100%',
    maxWidth: 400,
    // Sombras para iOS
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.15,
    shadowRadius: 20,
    // Sombra para Android
    elevation: 10,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 24,
  },
  headerTextContainer: {
    flex: 1,
    paddingRight: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0f172a',
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 13,
    color: '#64748b',
  },
  closeButton: {
    padding: 6,
    borderRadius: 8,
    backgroundColor: '#f8fafc',
  },
  closeIcon: {
    fontSize: 18,
    color: '#94a3b8',
    fontWeight: 'bold',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    padding: 6,
  },
  input: {
    flex: 1,
    fontSize: 14,
    color: '#334155',
    paddingHorizontal: 12,
    ...Platform.select({
      android: {
        paddingVertical: 4, // Ajuste fino para Android não cortar o texto
      }
    })
  },
  copyButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonDefault: {
    backgroundColor: '#0f172a', // Grafite escuro
  },
  buttonSuccess: {
    backgroundColor: '#10b981', // Verde esmeralda
  },
  buttonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
  }
});